const FontStyling = {
    "heading-jumbo": "heading-jumbo",
    "heading-h1": "heading-h1",
    "heading-h2": "heading-h2",
    "heading-h3": "heading-h3",
    "heading-h4": "headline",
    "heading-h5": "heading-h5",
    "heading-h6": "heading-h6",
    "content-default": "content-default",
    "content-medium": "content-medium",
    "content-small": "content-small",
    "caption-1": "caption-1",
    "caption-2": "caption-2"
};
var font_styling = Object.freeze(FontStyling);

export { font_styling as default };
//# sourceMappingURL=font_styling.js.map
